import projectDefaults from 'helpers/projects/projectDefaults'

export default function initialProject(title) {
  return Object.assign({}, projectDefaults(), title && { title })
}



// WEBPACK FOOTER //
// ./src/helpers/projects/initialProject.js